/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Kullanim_S14_I4Inputs */

const tr_kullanim_s14_i4 = /** @type {(inputs: Kullanim_S14_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adli veya idari makam talebi`)
};

const en_kullanim_s14_i4 = /** @type {(inputs: Kullanim_S14_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Request of a judicial or administrative authority`)
};

const de_kullanim_s14_i4 = /** @type {(inputs: Kullanim_S14_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ersuchen einer Justiz- oder Verwaltungsbehörde`)
};

const ru_kullanim_s14_i4 = /** @type {(inputs: Kullanim_S14_I4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Запрос судебного или административного органа`)
};

/**
* | output |
* | --- |
* | "Request of a judicial or administrative authority" |
*
* @param {Kullanim_S14_I4Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const kullanim_s14_i4 = /** @type {((inputs?: Kullanim_S14_I4Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Kullanim_S14_I4Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_kullanim_s14_i4(inputs)
	if (locale === "de") return de_kullanim_s14_i4(inputs)
	if (locale === "ru") return ru_kullanim_s14_i4(inputs)
	return tr_kullanim_s14_i4(inputs)
});